export default {"src":"/_next/static/media/ella-ai-tm.85bbfa16.svg","height":63,"width":205,"blurWidth":0,"blurHeight":0};